import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles(() => ({
  cardAvatarContainer: (props) => props,
}));
